// extracted by mini-css-extract-plugin
export var container = "_d6-0";
export var icon = "_d6-1";
export var text = "_d6-2";